var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback, useLayoutEffect, useState } from "react";
import styled from "styled-components";
import { Box } from "./Box";
import { Flex } from "./Flex";
const FadeBox = styled(Box)({
    content: "",
    pointerEvents: "none",
    position: "relative",
}, ({ direction, fadePx, theme: { colors: { background, mainText }, space, }, }) => ({
    background: `linear-gradient(to ${direction === "up" ? "bottom" : "top"}, ${background}FF 0%, ${background}00 100%)`,
    color: mainText,
    height: space[fadePx],
    marginBottom: direction === "up" ? `-${space[fadePx]}px` : undefined,
    marginTop: direction === "down" ? `-${space[fadePx]}px` : undefined,
}));
export const FadeScroll = (_a) => {
    var { children, "data-testid": dataTestid = "fadeScroll", fadePx, height, id } = _a, rest = __rest(_a, ["children", "data-testid", "fadePx", "height", "id"]);
    const [showTopBox, setShowTopBox] = useState(false);
    const [showBottomBox, setShowBottomBox] = useState(true);
    const [, setScrollTop] = useState(0);
    const ref = React.createRef();
    // createRef will give you the same ref object on every render, current is the mutable property.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useLayoutEffect(() => {
        if (ref.current) {
            const top = ref.current.scrollTop;
            if (top === 0) {
                setShowTopBox(false);
                // Check if the total content is large enough to be scrollable in that container's size
                setShowBottomBox(ref.current.clientHeight < ref.current.scrollHeight);
            }
            else {
                setShowTopBox(true);
                setShowBottomBox(top + ref.current.clientHeight < ref.current.scrollHeight - fadePx);
            }
        }
    });
    // Re-render on scroll, trigger the useLayoutEffect
    const onScroll = useCallback((event) => {
        setScrollTop(event.target.scrollTop);
    }, []);
    return (React.createElement(Flex, Object.assign({ "data-testid": dataTestid, flexDirection: "column", width: "100%", position: "relative" }, rest),
        showTopBox && React.createElement(FadeBox, { "data-testid": "showTopBox", direction: "up", fadePx: fadePx }),
        React.createElement(Flex, { "data-testid": `${dataTestid}ChildrenContainer`, flexDirection: "column", id: id, maxHeight: height, onScroll: onScroll, overflow: "auto", ref: ref }, children),
        showBottomBox && React.createElement(FadeBox, { "data-testid": "showBottomBox", direction: "down", fadePx: fadePx })));
};
